// extracted by mini-css-extract-plugin
export default {"container":"container___zDO9e","mask":"mask___lnupp","text":"text___hfABE","text-red":"text-red___XOTwT","text-blue":"text-blue___AmcSY","close-btn":"close-btn___OhhWJ"};